import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d2a1bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leaderboard" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "leaderboard-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Name ", -1))
const _hoisted_5 = { class: "leaderboard-row-eth" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "pagination" }

import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon } from '@heroicons/vue/solid';
import dayjs from 'dayjs/esm/index';
import calendar from 'dayjs/esm/plugin/calendar';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import _ from 'lodash';
import { computed, ref } from 'vue';

export interface MembershipRecord {
walletAddress: string;
ens?: string;
date: Date;
}

interface HoldersProps {
membershipRecords: MembershipRecord[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Holders',
  props: {
    membershipRecords: {}
  },
  setup(__props: any) {

const props = __props;

dayjs.extend(calendar);
dayjs.extend(relativeTime);



const currentPage = ref(1);
const perPage = ref(10); // Adjust this value to set the number of items per page
const sortBy = ref('date');
const sortDirection = ref('desc'); // Change to 'asc' for ascending order by default

const paginatedMembershipRecords = computed(() => {
  const start = (currentPage.value - 1) * perPage.value;
  const end = currentPage.value * perPage.value;
  const sortedRecords = _.orderBy(props.membershipRecords, sortBy.value, sortDirection.value);
  return sortedRecords.slice(start, end);
});
const totalPages = computed(() => {
  return Math.ceil(props.membershipRecords.length / perPage.value);
});

function toggelSort () {
  sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
}

function nextPage () {
  if (currentPage.value >= totalPages.value) return;
  currentPage.value++;
}

function previousPage () {
  if (currentPage.value === 1) return;
  currentPage.value--;
}

const getWalletAddressShorten = (address: string) : string => {
  if (!address) return '';
  return `${address.substring(0, 5)}...${address.substring(39, 42)}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createTextVNode(_toDisplayString(`🔒Token Holders `) + " "),
        _createElementVNode("span", null, _toDisplayString(`(${_ctx.membershipRecords.length})`), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("h3", { onClick: toggelSort }, [
        _createTextVNode(" Since "),
        _createElementVNode("span", null, [
          (sortDirection.value === 'desc')
            ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                key: 0,
                class: "chevron"
              }))
            : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 1,
                class: "chevron"
              }))
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMembershipRecords.value, (record, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "leaderboard-row"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            target: "_blank",
            href: `https://etherscan.io/address/${record.walletAddress}`
          }, _toDisplayString(`${record.ens ?? getWalletAddressShorten(record.walletAddress)}`), 9, _hoisted_6)
        ]),
        _createElementVNode("a", null, _toDisplayString(_unref(dayjs)(record.date).fromNow()), 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, _toDisplayString(`${((currentPage.value - 1) * perPage.value) + 1}-${currentPage.value*perPage.value > _ctx.membershipRecords.length ? _ctx.membershipRecords.length : currentPage.value*perPage.value} of ${_ctx.membershipRecords.length}`), 1),
      _createVNode(_unref(ChevronLeftIcon), {
        class: _normalizeClass(`chevron ${currentPage.value === 1 ? 'disabled' : ''}`),
        onClick: previousPage
      }, null, 8, ["class"]),
      _createVNode(_unref(ChevronRightIcon), {
        class: _normalizeClass(`chevron ${currentPage.value >= totalPages.value ? 'disabled' : ''}`),
        onClick: nextPage
      }, null, 8, ["class"])
    ])
  ]))
}
}

})